export default __webpack_public_path__ + "static/media/ImagineScience.fec3ae44.png";